import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'components/ui/button';
import { Input } from 'components/ui/input';
import { Label } from 'components/ui/label';
import { Logo } from 'components/Logo';
import api, { getApiErrorMessage } from 'lib/api';
import { toast } from 'sonner';
import { useLanguage } from 'lib/i18n';
import { LanguageSwitcher } from 'components/LanguageSwitcher';
import { Mail, Loader2 } from 'lucide-react';

export default function ForgotPasswordPage() {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
      toast.success(t('auth.forgotSentToast'));
    } catch (err) {
      toast.error(getApiErrorMessage(err, t('auth.forgotError')));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md">
        <div className="mb-6 flex items-center justify-between"><Logo /><LanguageSwitcher /></div>
        <h1 className="text-3xl font-bold mb-2">{t('auth.forgotTitle')}</h1>
        <p className="text-muted-foreground mb-6">{t('auth.forgotText')}</p>
        {sent ? (
          <div className="p-4 rounded-lg bg-emerald-50 text-emerald-800 border border-emerald-200">
            {t('auth.sentIfExists')} {email}, {t('auth.resetLinkSent')}
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
                <Input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="pl-9" data-testid="forgot-email-input" />
              </div>
            </div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-button">
              {loading ? <Loader2 className="animate-spin" size={16} /> : t('auth.send')}
            </Button>
          </form>
        )}
        <p className="text-center text-sm text-muted-foreground mt-6">
          <Link to="/login" className="text-primary hover:underline">{t('auth.backLogin')}</Link>
        </p>
      </div>
    </div>
  );
}
